// SegurIA v3.0.0 — matriz de roles (espejo de ROLE_LABELS / _require_role del backend)

export const ROLE_LABELS = {
  superadmin: 'Super Administrador',
  admin: 'Administrador',
  auditor: 'Auditor',
  viewer: 'Observador',
};

export const ROLE_CATALOG = [
  {
    value: 'admin',
    label: 'Administrador',
    summary: 'Dueño de la cuenta de la empresa.',
    can: [
      'Crear y administrar usuarios y sus roles',
      'Plan, facturación y módulos contratados',
      'Dar de alta objetivos y firmar autorizaciones de escaneo',
      'Generar tokens del agente interno',
      'Ejecutar escaneos y gestionar hallazgos',
      'Ver dashboards y descargar reportes',
    ],
    cannot: ['Administrar otras empresas de la plataforma'],
  },
  {
    value: 'auditor',
    label: 'Auditor',
    summary: 'Opera el día a día de seguridad.',
    can: [
      'Ejecutar escaneos sobre los objetivos ya autorizados',
      'Gestionar hallazgos: estado, validación de analista, mapeo de pérdida',
      'Ver dashboards y descargar reportes',
    ],
    cannot: [
      'Crear usuarios o cambiar roles',
      'Tocar el plan, la facturación o los módulos',
      'Dar de alta objetivos o firmar autorizaciones legales',
      'Generar tokens del agente interno',
    ],
  },
  {
    value: 'viewer',
    label: 'Observador',
    summary: 'Solo lectura. Ideal para dirección, auditoría externa o el broker de seguros.',
    can: ['Ver dashboards, hallazgos y Cyber Grade', 'Descargar reportes en PDF'],
    cannot: ['Ejecutar escaneos', 'Modificar hallazgos', 'Cualquier tarea administrativa'],
  },
];

export const normalizeRole = (role) => String(role || '').toLowerCase().replace('userrole.', '').trim();

export const isSuperAdmin = (user) => normalizeRole(user?.role) === 'superadmin';
export const isAdmin = (user) => ['admin', 'superadmin'].includes(normalizeRole(user?.role));
export const canOperate = (user) => ['admin', 'auditor', 'superadmin'].includes(normalizeRole(user?.role));
export const roleLabel = (user) => ROLE_LABELS[normalizeRole(user?.role)] || normalizeRole(user?.role) || '—';
